/** Prefijos de rutas que no deben inicializar Keycloak ni llamar al API de organización. */
const PUBLIC_PATH_PREFIXES = [
  '/evento-publico',
  '/terminos-condiciones',
  '/inicio',
] as const;

export function isPublicAppPath(pathname?: string): boolean {
  const path =
    pathname ??
    (typeof globalThis !== 'undefined' &&
    'location' in globalThis &&
    globalThis.location
      ? globalThis.location.pathname
      : '');
  return PUBLIC_PATH_PREFIXES.some((p) => path.startsWith(p));
}
